var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-board"},[_c('game-info',{attrs:{"score":_vm.score,"view":_vm.view,"roomName":_vm.room.title}}),_c('card-area',{attrs:{"room":_vm.room,"view":_vm.view}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }